import React from "react";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

export function UiRadioBtn(props) {
     const { label, value, className, checked, disabled, ...rest } = props;

     return (
          <>
               <FormControlLabel
                    {...rest}
                    disabled={disabled}
                    checked={checked}
                    onClick={props.onClick}
                    value={value}
                    control={<Radio />}
                    label={label}
                    className={className}
               />
          </>
     );
}
